<template>
  <vx-card title="More Information" class="mb-base" v-if="countTabDatas > 0">
    <div class="vx-row">
      <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
        <vs-tab
          v-for="(val,id) in pagetabDatas"
          :key="id"
          :label="val.label"
          icon-pack="feather"
          :icon="val.icon"
        >
          <div class="tab-text">
            <advance-table :key="val.tableSettings.route" :mainSettings="val"></advance-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import AdvanceTable from "../advance_table.vue";
import { settingsMixin } from "../settingsMixin"; 

export default { 
  mixins: [settingsMixin],
  data() {
    return {
      activeTab: 0
    };
  },
  components: {
    AdvanceTable
  },
  computed: {
    pagetabDatas() { 
      return this.getTabDatas(this.$route.params.subject,true);
    },
    countTabDatas(){
      return  Object.entries(this.pagetabDatas).length;
    }
  },
  created() {},
  methods: {}
};
</script>